import Report from '@/components/admin/Report'

const ReportManagement = () => {
  return <Report />
}

export default ReportManagement